import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getTasksByTenantId } from "../store/tasks/thunks";
import { selectTasksState } from "../store/tasks/selectors";
import { updateColumnsIndex } from "../store/tasks/slice";

export const useTenantTasks = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { columnsByTenants, loading, selectedTask } =
    useSelector(selectTasksState);

  useEffect(() => {
    if (selectedTenantId && !columnsByTenants?.[selectedTenantId]) {
      dispatch(
        getTasksByTenantId({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, columnsByTenants]);

  const columns = useMemo(() => {
    return columnsByTenants[selectedTenantId] || {};
  }, [columnsByTenants, selectedTenantId]);

  const setColumns = useCallback(
    (values) => {
      dispatch(
        updateColumnsIndex({
          tenant_id: selectedTenantId,
          columns: values,
        }),
      );
    },
    [columns],
  );
  return { columns, loading, selectedTenantId, selectedTask, setColumns };
};
